import {
    PRODUCT_CTA,
    PRODUCT_FULL,
    PRODUCT_GRID,
    PRODUCT_CROSS_SELL,
    PRODUCT_MEDIA_CAROUSEL_NAV,
    PRODUCT_QUANTITY_SELECTOR,
    PRODUCT_RATING_WRAPPER,
    PRODUCT_SIZE_PICKER,
    PRODUCT_SHADE_PICKER,
    PRODUCT_SHADE_PICKER_BUTTON,
    PRODUCT_BASIC_INFO,
    PRODUCT_FULL_ORDERABLE,
    PRODUCT_COMPARISON_MODULE
} from 'elc-service-view-names';
import { Service, ServiceInitializer } from 'elc-service';
import { ProductServiceStartedUseCase } from '../internal/use-cases/ProductServiceStartedUseCase';
import { diContainer, serviceNames } from './diContainer';
import { useStaticRendering } from 'mobx-react';
import { root } from 'elc-universal-utils';

const { name, version } = __serviceInfo__;

export class ProductService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
        useStaticRendering(root.__ssr);
        this.registerView(
            PRODUCT_FULL,
            () =>
                import(
                    /* webpackChunkName: 'ProductFull' */
                    '../exported/product-full/ProductFull'
                ),
            () => diContainer.get(serviceNames.productFullViewController)
        );

        this.registerView(
            PRODUCT_FULL_ORDERABLE,
            () =>
                import(
                    /* webpackChunkName: 'ProductFullOrder' */
                    '../exported/product-full-order/ProductFullOrderable'
                ),
            () => diContainer.get(serviceNames.productFullOrderableViewController)
        );

        this.registerView(
            PRODUCT_GRID,
            () =>
                import(
                    /* webpackChunkName: 'ProductGrid' */
                    '../exported/product-grid-wrapper/ProductGridWrapper'
                ),
            () => diContainer.get(serviceNames.productGridViewController)
        );

        this.registerView(
            PRODUCT_RATING_WRAPPER,
            () =>
                import(
                    /* webpackChunkName: 'ProductRatingWrapper' */
                    '../exported/product-rating/ProductRatingWrapper'
                ),
            () => diContainer.get(serviceNames.productRatingViewController)
        );

        this.registerView(
            PRODUCT_CROSS_SELL,
            () =>
                import(
                    /* webpackChunkName: 'ProductCrossSell' */
                    '../exported/product-cross-sell/ProductCrossSell'
                ),
            () => diContainer.get(serviceNames.productCrossSellViewController)
        );

        this.registerView(
            PRODUCT_CTA,
            () =>
                import(
                    /* webpackChunkName: 'ProductCTA' */
                    '../exported/product-cta/ProductCTA'
                ),
            () => diContainer.get(serviceNames.productCTAViewController)
        );

        this.registerView(PRODUCT_SIZE_PICKER, () =>
            import(
                /* webpackChunkName: 'ProductSizePicker' */
                '../exported/product-size-picker-wrapper/ProductSizePickerWrapper'
            )
        );

        this.registerView(PRODUCT_QUANTITY_SELECTOR, () =>
            import(
                /* webpackChunkName: 'ProductQuantitySelector' */
                '../exported/product-quantity-selector/ProductQuantitySelector'
            )
        );

        this.registerView(
            PRODUCT_SHADE_PICKER,
            () =>
                import(
                    /* webpackChunkName: 'ProductShadePicker' */
                    '../exported/product-shade-picker/ProductShadePicker'
                ),
            () => diContainer.get(serviceNames.productShadePickerViewController)
        );

        this.registerView(PRODUCT_SHADE_PICKER_BUTTON, () =>
            import(
                /* webpackChunkName: 'ProductShadePickerButtonWrapper' */
                '../internal/views/product-shade-picker/ProductShadePickerButtonWrapper'
            )
        );
        this.registerView(PRODUCT_MEDIA_CAROUSEL_NAV, () =>
            import(
                /* webpackChunkName: 'ProductImageNavMenu' */
                '../exported/product-image-nav-menu/ProductImageNavMenu'
            )
        );

        this.registerView(
            PRODUCT_BASIC_INFO,
            () =>
                import(
                    /* webpackChunkName: 'ProductCard' */
                    '../exported/product-basic-info/ProductBasicInfo'
                ),
            () => diContainer.get(serviceNames.productBasicInfoViewController)
        );

        this.registerView(
            PRODUCT_COMPARISON_MODULE,
            () =>
                import(
                    /* webpackChunkName: 'ProductComparisonModule' */
                    '../exported/product-comparison-module/ProductComparisonModule'
                ),
            () => diContainer.get(serviceNames.productComparisonModuleViewController)
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async start(config: any) {
        const service = await super.start(config);

        const productServiceStartedUseCase = new ProductServiceStartedUseCase([
            'currency',
            'itemMaxQuantity',
            'businessUnitId',
            'features',
            'graphqlExtensionVersion',
            'imagesSizes',
            'imageCarouselSettings',
            'shortDescription',
            'domainLangPrefix'
        ]);

        await productServiceStartedUseCase.execute();

        return service;
    }
}
